import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

interface FooterLink {
  label: string;
  route: string;
  icon?: string;
  external?: boolean;
}

interface FooterSection {
  title: string;
  icon: string;
  links: FooterLink[];
}

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  appVersion = '5.0.0';
  angularVersion = '20';
  firebaseVersion = '11';

  // Footer navigation sections (3 columns, displayed alongside brand section)
  footerSections: FooterSection[] = [
    {
      title: 'Sistem',
      icon: 'dashboard',
      links: [
        { label: 'Ana Sayfa', route: '/' },
        { label: 'Site Haritası', route: '/site-haritasi' },
        { label: 'Çerez Politikası', route: '/cerez-politikasi' }
      ]
    },
    {
      title: 'Dokümantasyon',
      icon: 'menu_book',
      links: [
        { label: 'Kullanım Kılavuzu', route: '/kullanim-kilavuzu' },
        { label: 'Teknik Özellikler', route: '/teknik-ozellikler' },
        { label: 'Sık Sorulan Sorular', route: '/sik-sorulanlar' }
      ]
    },
    {
      title: 'Yasal',
      icon: 'policy',
      links: [
        { label: 'Gizlilik Politikası', route: '/gizlilik-politikasi' },
        { label: 'KVKK Bilgilendirme', route: '/kisisel-veri-gizliligi' },
        { label: 'Kullanım Koşulları', route: '/kullanim-kosullari' }
      ]
    }
  ];

  socialLinks = [
    { icon: 'language', label: 'Web Sitesi', url: 'https://farturk.com', ariaLabel: 'FARTURK Web Sitesi' }
  ];

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
